import React from "react";
import { useFormContext } from "react-hook-form";
import InputArea from "../../../common/components/FormFields/InputArea";
import InputField from "../../../common/components/FormFields/InputField";

export default function PlanofCare(props) {
  const {
    handleSubmit,
    reset,
    formState: { errors },
    control,
    register,
    setValue,
    watch,
  } = useFormContext({
    // resolver: yupResolver(validationSchema),
    // defaultValues: defaultValues,
  });
  return (
    <div>
      <div className="flex justify-between bg-[#DBEAFE] rounded-t-md">
        <p className="text-sm font-semibold w-full pl-2 py-1">Plan of Care</p>
      </div>
      <div
        className={`${
          props.from === "generalEMR"
            ? "max-h-32"
            : props.from === "cardiology"
            ? "h-40"
            : ""
        } grid xl:grid-cols-2 xl:gap-2 overflow-auto border p-1 pb-2 border-[#D9D9D9] rounded-b-md bg-white px-2`}
      >
        <div className="w-full lg:mb-2">
          <InputArea
            control={control}
            name="immediateManagement"
            label="Immediate Management"
          />
        </div>
        <div>
          <InputArea
            control={control}
            name="provideMeasuresifany"
            label="Preventive Measures If any"
          />
        </div>
      </div>
    </div>
  );
}

